module.exports = __webpack_public_path__ + "img/border_star.09e49a1e.svg";